var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-number',_vm._b({model:{value:(_vm.price),callback:function ($$v) {_vm.price=$$v},expression:"price"}},'vue-number',_vm.number,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }